// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/seller_profession.proto" (package "bianka.event.activity.v2.extension", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Model } from "../../../../core/enrichment/model";
import { User } from "../../../../core/enrichment/user";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.SellerProfession
 */
export interface SellerProfession {
    /**
     * The seller profession/role
     *
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.SellerProfession.Profession profession = 1
     */
    profession?: SellerProfession_Profession;
    /**
     * The seller profession variant
     * Profession can have several variants where each variant repsesents more specific version of that profession
     * Example:
     * ** Profession: "SEO specialists"
     * ** Variations: "Yahoo SEO specialist", "Bing SEO specialist"
     *
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.SellerProfession.Variant variant = 2
     */
    variant?: SellerProfession_Variant;
    /**
     * The title that is calculated based on the seller's profession and variant
     *
     * @generated from protobuf field: optional string computed_title = 3
     */
    computedTitle?: string;
    /**
     * The page name where the event was originated from
     *
     * @generated from protobuf field: string page_name = 4
     */
    pageName: string;
    /**
     * The seller whose page was visited
     *
     * @generated from protobuf field: optional bianka.core.enrichment.User seller = 5
     */
    seller?: User;
    /**
     * Model id
     *
     * @generated from protobuf field: optional bianka.core.enrichment.Model model = 7
     */
    model?: Model;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.SellerProfession.Profession
 */
export interface SellerProfession_Profession {
    /**
     * The profession/role id [by product definition]
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The sellerRole id (nested under role) [by product definition]
     *
     * @generated from protobuf field: string seller_profession_id = 2
     */
    sellerProfessionId: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.SellerProfession.Variant
 */
export interface SellerProfession_Variant {
    /**
     * The variant id
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The variant type
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.SellerProfession.VariantType type = 2
     */
    type: SellerProfession_VariantType;
}
/**
 * @generated from protobuf enum bianka.event.activity.v2.extension.SellerProfession.VariantType
 */
export enum SellerProfession_VariantType {
    /**
     * @generated from protobuf enum value: VARIANT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: VARIANT_TYPE_MD = 1;
     */
    MD = 1,
    /**
     * @generated from protobuf enum value: VARIANT_TYPE_ROLE = 2;
     */
    ROLE = 2,
    /**
     * @generated from protobuf enum value: VARIANT_TYPE_SERVICE = 3;
     */
    SERVICE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SellerProfession$Type extends MessageType<SellerProfession> {
    constructor() {
        super("bianka.event.activity.v2.extension.SellerProfession", [
            { no: 1, name: "profession", kind: "message", T: () => SellerProfession_Profession },
            { no: 2, name: "variant", kind: "message", T: () => SellerProfession_Variant },
            { no: 3, name: "computed_title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "seller", kind: "message", T: () => User },
            { no: 7, name: "model", kind: "message", T: () => Model }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
    create(value?: PartialMessage<SellerProfession>): SellerProfession {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageName = "";
        if (value !== undefined)
            reflectionMergePartial<SellerProfession>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SellerProfession): SellerProfession {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bianka.event.activity.v2.extension.SellerProfession.Profession profession */ 1:
                    message.profession = SellerProfession_Profession.internalBinaryRead(reader, reader.uint32(), options, message.profession);
                    break;
                case /* optional bianka.event.activity.v2.extension.SellerProfession.Variant variant */ 2:
                    message.variant = SellerProfession_Variant.internalBinaryRead(reader, reader.uint32(), options, message.variant);
                    break;
                case /* optional string computed_title */ 3:
                    message.computedTitle = reader.string();
                    break;
                case /* string page_name */ 4:
                    message.pageName = reader.string();
                    break;
                case /* optional bianka.core.enrichment.User seller */ 5:
                    message.seller = User.internalBinaryRead(reader, reader.uint32(), options, message.seller);
                    break;
                case /* optional bianka.core.enrichment.Model model */ 7:
                    message.model = Model.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SellerProfession, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional bianka.event.activity.v2.extension.SellerProfession.Profession profession = 1; */
        if (message.profession)
            SellerProfession_Profession.internalBinaryWrite(message.profession, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional bianka.event.activity.v2.extension.SellerProfession.Variant variant = 2; */
        if (message.variant)
            SellerProfession_Variant.internalBinaryWrite(message.variant, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional string computed_title = 3; */
        if (message.computedTitle !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.computedTitle);
        /* string page_name = 4; */
        if (message.pageName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageName);
        /* optional bianka.core.enrichment.User seller = 5; */
        if (message.seller)
            User.internalBinaryWrite(message.seller, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional bianka.core.enrichment.Model model = 7; */
        if (message.model)
            Model.internalBinaryWrite(message.model, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.SellerProfession
 */
export const SellerProfession = new SellerProfession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SellerProfession_Profession$Type extends MessageType<SellerProfession_Profession> {
    constructor() {
        super("bianka.event.activity.v2.extension.SellerProfession.Profession", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "seller_profession_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SellerProfession_Profession>): SellerProfession_Profession {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.sellerProfessionId = "";
        if (value !== undefined)
            reflectionMergePartial<SellerProfession_Profession>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SellerProfession_Profession): SellerProfession_Profession {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string seller_profession_id */ 2:
                    message.sellerProfessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SellerProfession_Profession, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string seller_profession_id = 2; */
        if (message.sellerProfessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sellerProfessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.SellerProfession.Profession
 */
export const SellerProfession_Profession = new SellerProfession_Profession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SellerProfession_Variant$Type extends MessageType<SellerProfession_Variant> {
    constructor() {
        super("bianka.event.activity.v2.extension.SellerProfession.Variant", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["bianka.event.activity.v2.extension.SellerProfession.VariantType", SellerProfession_VariantType, "VARIANT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SellerProfession_Variant>): SellerProfession_Variant {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<SellerProfession_Variant>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SellerProfession_Variant): SellerProfession_Variant {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bianka.event.activity.v2.extension.SellerProfession.VariantType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SellerProfession_Variant, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bianka.event.activity.v2.extension.SellerProfession.VariantType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.SellerProfession.Variant
 */
export const SellerProfession_Variant = new SellerProfession_Variant$Type();
